import React from 'react';

const SimpleLoadingScreen = ({ message = 'Loading...' }) => {
  // Only show if the main app has finished loading
  const isMainAppLoading = document.querySelector('.fixed.inset-0.z-50') !== null;
  
  if (isMainAppLoading) {
    return null;
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-50 via-white to-purple-50 dark:from-gray-900 dark:via-gray-800 dark:to-purple-900">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600 mx-auto mb-3"></div>
        <p className="text-sm text-gray-600 dark:text-gray-400">{message}</p>
      </div>
    </div>
  );
};

export default SimpleLoadingScreen; 